//will take a s3 url as prop, and a file input with a submit button. 
import React, { useState} from "react";
import uploadImageToS3 from "../actions/uploadImageToS3";
import { toast } from "react-toastify";
import {updateImageURL} from '../actions/updateDB'
import {useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';


const NewSiteImageUploadForm = ({ signedURL, jobsiteID }) => {
    const [image, setImage] = useState(null);
    const { token } = useSelector((state) => state.auth.user);
    const fileInputRef = React.useRef(null);
    const navigate = useNavigate();

    const uploadImage = async (e) => {
        e.preventDefault();

        if (!image) {
            console.log("No image selected");
            return;
        } else {
            try {
                const imageObjectUrl = await uploadImageToS3(image, signedURL);

                if (imageObjectUrl) {
                    try {
                        const updateDatabase = await updateImageURL(imageObjectUrl, jobsiteID, token);
                        toast.success('Image uploaded successfully');
                        navigate('/jobsites');
                    } catch (error) {
                        console.log("Error updating the database: " + error);
                    }
                }
            } catch (error) {
                console.log("Error uploading the image: " + error);
            }
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files && files[0]) {
            setImage(files[0]);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDropAreaClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleDropAreaKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleDropAreaClick();
        }
    };

    return (
        <div className="flex flex-col items-center justify-center p-4 m-6 bg-surface border border-border rounded-xl shadow-sm">
            <h1 className="text-card-title text-ink mb-4">Upload Jobsite Image</h1>
            <form onSubmit={uploadImage}>
                <div
                    className="w-full h-32 border-2 border-dashed border-border flex items-center justify-center text-ink-3 mb-4 cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand/40 rounded-md"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    tabIndex={0}
                    role="button"
                    aria-label="Upload image: drag, click, or tap to select"
                    onClick={handleDropAreaClick}
                    onKeyDown={handleDropAreaKeyDown}
                >
                    {image ? (
                        <p className="text-body text-ink">{image.name}</p>
                    ) : (
                        <p className="text-body text-center px-4">
                            Drag & drop, <span className="underline">click</span>, or <span className="underline">tap</span> here to take a photo or choose an image
                        </p>
                    )}
                </div>
                <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={(e) => setImage(e.target.files[0])}
                    tabIndex={-1}
                />
                <button
                    type="submit"
                    className="mt-4 bg-ink text-white rounded-lg text-label font-medium px-4 py-2 hover:bg-ink-2"
                >
                    Upload Image
                </button>
            </form>
        </div>
    );
};

export default NewSiteImageUploadForm;